
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { lAreaData } from "@/const/LAreaData";
import { getDepartmentList } from "@/api/company";
import { getPartsList } from "@/api/parts";
import { addGroupView, editGroupView } from "@/api/group";

@Component({
  name: "PartsGroups",
  components: {},
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  dialogPartsGroupsVisible: any;
  @Prop({
    type: Object,
    default: () => {},
  })
  editorData!: any;

 private active = 0
 // 部门
 private checkboxDept: any = [];
 private checkboxDeptTop:any=[];

 private listData:any = [];
  private listQuery: any = {
    deptmentName: "",
    area: "",
  };
  private lAreaData!: any;
  private defaultProps: any = {
    children: "child",
    label: "name",
    value: "id",
  };
  // 备件
  private listQueryParts = {
    name: "",
  };
  private checkboxParts: any = [];
  private checkboxPartsTop:any=[];
  private partsData:any = [];
  created() {
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item &&
          item.child &&
          item.child.map((temp: any) => {
            if (temp && temp.child && temp.child.length === 0) {
              (temp.child as any) = undefined;
            }
          });
      }
    });
    this.getDepartmentListAll()
  }
  private searchDept() {
    this.getDepartmentListAll()
  }
  private clearDept() {
    this.listQuery = {
      deptmentName: "",
      area: "",
    };
    this.getDepartmentListAll()
  }
  private changeDept(val:any) {
    this.checkboxDeptTop = val
  }
  private closeDeptHandle(item:any) {
    const index = this.checkboxDept.map((val: any) => val.id).indexOf(item.id);
    this.checkboxDeptTop.splice(index, 1)
    this.checkboxDept.splice(index, 1);
  }
  private deptPage=1;
  private isDeptLoadMore=false;
  private loadMoreDept() {
    this.deptPage = this.deptPage + 1
    this.getDepartmentListAll()
  }
  private getDepartmentListAll() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      type: '2', // type=9 查所有部门  type=2查服务部门
      page: this.deptPage,
      size: 10,
      is_department_list: 1
    };
    if (this.listQuery.deptmentName) {
      params.name = this.listQuery.deptmentName;
    }
    if (this.listQuery.area) {
      params.address = this.listQuery.area;
    }
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          if (this.deptPage === 1) {
            this.listData = res.data.list
          } else {
            this.listData = this.listData.concat(res.data.list)
          }
          if (this.deptPage >= res.data.page_count) {
            this.isDeptLoadMore = false
          } else {
            this.isDeptLoadMore = true
          }
          for (let i = 0; i < this.listData.length; i++) {
            let cont:any = this.listData[i];
            cont.area = this.listData[i].province_name + this.listData[i].city_name + this.listData[i].district_name;
            this.$set(this.listData, cont, i);
          }
          this.setDeptSelect(res.data.list);
        } else {
          this.listData = []
          this.isDeptLoadMore = false
        }
      })
      .catch(err => {
        let msg = err.msg;
        this.isDeptLoadMore = false
      });
  }
  private setDeptSelect(list:any) {
    if (this.editorData && this.editorData.department_list && this.editorData.department_list.length > 0) {
      this.checkboxDeptTop = this.editorData.department_list
      list.forEach((item:any) => {
        this.editorData.department_list.forEach((itemd:any) => {
          if (itemd.id === item.dept_id) {
            this.checkboxDept.push(item)
          }
        });
      });
    } else {
      this.checkboxDeptTop = []
      this.checkboxDept = []
    }
  }
  private nextStep() {
    if (this.active === 1) {
      if (!this.checkboxDeptTop || this.checkboxDeptTop.length < 1) {
        this.showErrorMsg(' 请选择部门')
        return
      }
      this.active = 2;
      if (!(this.partsData && this.partsData.length > 0)) {
        this.getPartsList()
      }
    }
    if (this.active === 0) {
      (this.$refs.formName as any).validate((valid: any) => {
        if (valid) {
          this.active = 1
        } else {
          return false;
        }
      });
    }
  }
  private uptStep() {
    if (this.active === 2) {
      this.active = 1
    } else {
      this.active = 0
    }
  }
  private confirmHandle() {
    if (!this.checkboxPartsTop || this.checkboxPartsTop.length < 1) {
      this.showErrorMsg(' 请选择备件')
      return
    }
    this.addGroup(this.editorData && this.editorData.id)
  }
  private addGroup(isEditor:boolean) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      group_type: 20,
      group_name: this.editorData.group_name,
    };
    let depts:any = []
    this.checkboxDeptTop.forEach((element:any) => {
      let dept = {
        id: element.id,
        name: element.name
      }
      depts.push(dept)
    });
    let parts:any = []
    this.checkboxPartsTop.forEach((element:any) => {
      let part = {
        id: element.id,
        name: element.name
      }
      parts.push(part)
    });
    params.departments = JSON.stringify(depts)
    params.parts = JSON.stringify(parts)
    if (isEditor) {
      params.group_id = this.editorData.id
      editGroupView(params).then((res:any) => {
        this.showSuccessMsg(res.msg)
        this.close(true)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      })
    } else {
      addGroupView(params).then((res:any) => {
        this.showSuccessMsg(res.msg)
        this.close(true)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      })
    }
  }
  // 备件
  private searchParts() {
    this.getPartsList()
  }
  private clearParts() {
    this.listQueryParts.name = ''
    this.getPartsList()
  }
  private changeParts(val:any) {
    this.checkboxPartsTop = val
  }
  private closePartsHandle(item:any) {
    const index = this.checkboxParts.map((val: any) => val.id).indexOf(item.id);
    this.checkboxPartsTop.splice(index, 1)
    this.checkboxParts.splice(index, 1);
  }
  private partPage=1;
  private isPartLoadMore=false;
  private loadMorePart() {
    this.partPage = this.partPage + 1
    this.getPartsList()
  }
  private getPartsList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_name: this.listQueryParts.name,
      page: this.partPage,
      size: 10
    };
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        if (data) {
          if (this.partPage === 1) {
            this.partsData = res.data.list
          } else {
            this.partsData = this.partsData.concat(res.data.list)
          }
          if (this.partPage >= res.data.page_count) {
            this.isPartLoadMore = false
          } else {
            this.isPartLoadMore = true
          }
          this.setPartsSelect(data.list)
        } else {
          this.isPartLoadMore = false
          this.partsData = [];
        }
      })
      .catch((err: any) => {
        this.isPartLoadMore = false
        this.partsData = [];
        let msg = err.msg;
      });
  }
  private setPartsSelect(list:any) {
    if (this.editorData && this.editorData.part_list && this.editorData.part_list.length > 0) {
      this.checkboxPartsTop = this.editorData.part_list
      list.forEach((item:any) => {
        this.editorData.part_list.forEach((itemd:any) => {
          if (itemd.id === item.id) {
            this.checkboxParts.push(item)
          }
        });
      });
    } else {
      this.checkboxPartsTop = [];
      this.checkboxParts = [];
    }
  }
  close(refresh: boolean) {
    this.$emit('close', false, refresh);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
